export default {
  accountValidateMsg:
    '帳號必須為6-30位元字元，包括字母、數位、“.”、“_”、“@”，第一位字元僅能為數位或字母。',
  storeSuccess: '儲值成功',
  editAccountTips: '請輸入有效帳號',
  editPwdTips: '請輸入有效密碼',
  editRepeatPwdTips: '請重複輸入密碼',
  pwdRepeatTips: '兩次密碼不匹配',
  changePwdSucc: '修改密碼成功',
  bindEmail: '綁定郵箱',
  errorVrifyCodeTips: '驗證碼錯誤',
  slectQuessionTips: '請選擇安全問題',
  answerTips: '請輸入答案',
  twoAnswerTips: '請選擇兩個您已經設置的安全問題，並輸入正確答案。',
  realNameValidateTips: '請輸入4~60位的真實姓名',
  phoneValidateTips: '請輸入6～18位元數位的電話號碼',
  areaSelectTips: '請選擇正確的國家地區',
  iDCardValidataTips: '請輸入1~60位的身份證號碼',
  changeProfileSucc: '資訊編輯成功',
  editVrfCodeTips: '請輸入驗證碼',
  securityQuestionTips:
    '請設置您的安全問題，提升您的帳號安全。當您忘記密碼時，可以通過回答安全問題快速重置密碼。',
  validateQuessionTips:
    '請選擇兩個不同的問題並進行認證，認證完成後便可重置安全問題。',
  originPwd: '請輸入舊密碼',
  newPwd: '請輸入新密碼',
  changePwdSuccess: '修改密碼成功，請手動重新登入帳號，防止資料丟失',
  accountName: '請輸入帳號名稱',
  password: '請輸入密碼',
  repeatPassword: '請再重複密碼',
  findPwdTips: '請輸入您需要找回密碼的帳號名稱',
  submit: '提交',
  send: '發送',
  modify: '修改',
  haveAgree: '我已同意',
  and: '和',
  privacyPolicy: '隱私權原則',
  completeness: '資料完成度:',
  gender: '性別',
  male: '男',
  female: '女',
  birthday: '生日',
  phone: '聯繫電話',
  region: '國家／地區',
  ID: '護照或身份證號碼',
  accountSetting: '帳號設置',
  upgrade: '帳號升級',
  profile: '個人資料',
  changePassword: '修改密碼',
  securityQuestion: '安全問題',
  creatework_headerTitle: '創建工單',
  mylist_headerTitle: '我的工單',
  bindEmailTips:
    '請認證一個您的常用郵箱，提升您的帳號安全。當您忘記密碼時，可通過此郵箱快速重置密碼。',
  enterEmailVrfcationTips: '請輸入收到的驗證碼',
  cancel: '取消',
  bindTps: '選擇帳戶綁定的方式可以讓你在數台設備中以您的帳號來進行遊戲!',
  login: '登入',
  logout: '登出',
  bind: '帳戶綁定',
  feedback: '問題回饋',
  terms: '相關條款',
  tips: '提示',
  debindTips:
    '解除綁定可能會導致您的帳號資料丟失，請您再次確認是否需要解除綁定！',
  debindText: '解除綁定',
  guestSwitchTips:
    '您當前已經有遊客帳戶存在，登錄後當前遊客帳戶會丟失，請問確認要登錄嗎？',
  register: '註冊',
  realName: '真實姓名',
  enterEmailTips: '請輸入郵箱位址',
  emailVAlidateMsg: '郵箱格式錯誤',
  editEmaileTips: '請輸入郵箱',
  checkServiceTips: '請先閱讀並接受服務條款和隱私政策！',
  brithdayValidateTips: '請選擇正確的生日',
  facebookValidateTips: '請輸入1~60位的facebook帳號',
  eritOriginPwdTips: '請輸入原密碼',
  submitSuccess: '提交成功',
  rebindEmail: '修改郵箱',
  bindEmailSuccess:
    '您已成功綁定郵箱$email</br>使用已綁定郵箱進行認證，認證完成便可重置郵箱。',
  reSetSecurityQuessoon:
    '您已經成功設置安全問題<br/><br/>選擇不同的問題並進行認證，認證完成後便可重置問題',
  canotModifyTips: '個人資料資訊提交後將不能更改，是否提交？',
  rebindEmailTips: '您的郵箱 $email,請點擊獲取驗證碼並輸入您收到的驗證碼',
  reGetVrfCode: '獲取驗證碼',
  findPwdWayTips: '請選擇以下方式找回',
  emailWay: '通過安全郵箱找回',
  emailWayTips: '你將收到一封確認郵件，可以重新設置密碼。',
  quessionWay: '通過安全問題找回',
  quessionWayTips: '回答已經設置的安全問題，可以重新設置密碼。',
  resetPwdBtn: '重置密碼',
  lastStep: '上一步',
  sendEmailTips:
    '我們已經向您的認證郵箱$email發送確認郵件。<br>請將您收到的驗證碼正確填入對話方塊中。',
  setNewPwdTips:
    '恭喜！<br>您可以重新設置密碼了，請在對話方塊中輸入您的新密碼吧！',
  termsOfUse: '服務條款',
  copy_success: '複製成功',
  creatework_create: '工單類',
  creatework_createHolder: '請選擇類型',
  creatework_title: '標題',
  creatework_titleHolder: '請輸入標題',
  creatework_detail: '問題詳情',
  creatework_detailHolder: '請輸入200字以內的問題詳情',
  creatework_uploadTips: '只能上傳jpg/png格式檔，檔不能超過5mb',
  creatework_selectBox_selectTile: '問題類型',
  creatework_goGame: '返回遊戲',
  creatework_history: '工單歷史',
  mylist_noYet: '您還沒有任何工單記錄喔',
  mywork_solved: '問題已解決了？點我',
  mywork_service: '給客服評分',
  mywork_messageHolder: '請輸入新消息',
  mywork_score: '請選擇評分',
  mywork_confirm: '確認',
  creatework_selectBox_selectList3: '其他問題',
  creatework_selectBox_selectList2: '帳號問題',
  close: '關閉',
  creatework_gameHolder: '請選擇遊戲',
  creatework_serverHolder: '請選擇伺服器',
  contactService: '聯繫客服',
  FAQ: 'FAQ',
  creatework_game: '遊戲：',
  creatework_server: '伺服器：',
  creatework_role: '角色：',
  selectRoleName: '請選擇角色',
  creatework_noRole: '還沒有創建角色',
  creatework_noGame: '遊戲列表為空',
  creatework_noServer: '伺服器列表為空',
  termText: '我已同意{mainHost}平台',
  backLogin: '返回登錄',
  creatework_roleHolder: '請選擇角色後再訪問',
  findPwdFailTips:
    '您沒有設置安全問題和安全郵箱，無法通過這種方式找回，請聯繫客服。',
  payMall: '儲值商城',
  selectPayment: '選擇金額',
  plzSelectPayWay: '請選擇您的管道',
  gainPlus: '加碼',
  gainMorePlus: '加碼多多',
  gainMostPlus: '最高加碼',
  plzSelectPayType: '選擇儲值方式',
  roleName: '角色名',
  payWay: '支付管道',
  plzSelectOtherWay: '選擇其他支付管道',
  payment: '支付金額',
  compensateTips: '超出商品價值部分將額外補償$gameCode給您',
  extaGain: '額外獲得',
  gameGold: '遊戲幣',
  compensate: '補償',
  payWayPlus: '管道加碼',
  neddPay: '需支付',
  submitOrder: '提交訂單',
  screenshotTips: '溫馨提示：截圖保存訂單資訊，後續遇到問題方便回饋哦！',
  storeFail: '儲值失敗',
  storeFailTips:
    '非常抱歉本次儲值失敗了，請您嘗試重新提交訂單，或通過客服工單聯繫我們',
  storeAcceptance: '受理中',
  storeSuccessTips: '儲值成功後通常在15MIN內到賬，請稍後於遊戲內查看',
  orderNumber: '訂單號',
  buyProduct: '儲值商品',
  transactionAmount: '交易金額',
  failReason: '失敗原因',
  payOntherORder: '再儲一筆',
  reStore: '重新儲值',
  confirm: '確定',
  switch: '帳號切換',
  completeTips:
    '請填寫您的個人資料， 以下資訊<mark class="yellowMarkColor">填寫後將不允許修改</mark>.當您的帳號丟失或被盜用時，可通過向客服提供準確的個人資料資訊作為取回帳號的依據。',
  creatework_selectBox_selectList0: '遊戲問題',
  creatework_selectBox_selectList1: '支付問題',
  creatework_selectBox_selectList4: '翻譯問題',
  mywork_solvedText: '問題已解決',
  browserPayErrBtnText: '交易遇到問題',
  browserPaySucBtnText: '已完成支付',
  browserPayingTips:
    '您正在前往協力廠商平臺進行支付,<br/>完成支付後即可關閉此頁面。',
  price_list_empty: '無可選金額',
  pointCardTips: '注意：商品僅支援等於 $paymentAmount 的 點卡購買',
  forgetPwd: '忘記密碼',
  payCenter: '平臺儲值中心',
  willGet: '您將獲得',
  goods: '商品',
  discount: '額外贈送',
  payDiscount: '支付補償',
  payDiscountTips: '超出商品價格將進行支付補償',
  hasQuestionPlease: '如有疑問，請',
  pwdValidateMsg: '密碼必須為6-20位字元',
  payWayPlusC: '渠道贈送',
  fwtk: '服務條款',
  yszc: '隱私政策',
  exchange: '禮包碼兌換',
  remember: '記住我',
  thirdInfo: '帳號規則說明',
  thirdInfoContent:
    '請在遊戲內的用戶中心完成帳號綁定，再使用綁定的帳號進行登錄。',
  unLink: '暫不支持此方式',
  favour: '收藏遊戲',
  goStoreTip: '請跳轉前往儲值頁面',
  go: '前往',
  otherLogin: '其他登錄方式',
  qrCodeTip: '掃一掃二維碼，馬上開啟旅程吧！',
  favourTip: '收藏頁面到瀏覽器，方便下次再玩喔～',
  share: '分享給朋友',
  landscapeTip: '請用豎屏方式進行操作',
  leaveTip: '您真的要離開遊戲嗎？',
  selectRole: '請選擇您要充值的角色',
  selectMoney: '請選擇想購買的道具',
  seletGameInfoFirst: '請先選擇遊戲信息',
  lowerIE: '您的IE版本過低',
  linkTermText: '我已同意{mainHost}平台[服務條款]和[隱私政策]',
  download: '下載',
  favourAndDownloadTip: '收藏到瀏覽器或者下載到電腦&lt;br/&gt;方便下次再玩',
  payReward: '支付有獎',
  hasEqualReward: '兩種支付方式同享首充雙倍等優惠',
  payBtnText: '儲值',
  storeHoaveReward: '儲值優惠',
  showMorePayWay: '展開更多支付方式',
  needPaymentCount: '需要支付金額',
  orderDetail: '訂單詳情',
  selectPayWayPlz: '選擇支付方式',
  countryCode: '國別碼',
  deleteaccount_title1: '帳號資訊刪除',
  deleteaccount_title2: '帳號刪除申請',
  deleteaccount_step1_1:
    '如果您執行帳號刪除後，您的帳號會被凍結14日。14日後您的帳號會被系統永久刪除，並且社交帳號後續也無法登錄。',
  deleteaccount_step1_2: '在凍結期間，您可以通過以下連結取消帳號刪除的請求',
  deleteaccount_step1_3:
    '帳號刪除後帳號所有資料全部清除且無法恢復，因帳號刪除造成的任何帳號財產損失也無法得到補償',
  deleteaccount_step1_4: '您是否需要這樣做？',
  deleteaccount_step2_1: '您確認要刪除當前帳號以及遊戲內所有角色資訊？',
  deleteaccount_step2_2: '請在輸入框中輸入“Delete”來完成刪除操作',
  deleteaccount_step3: '帳號刪除會在申請的14天后開始執行。',
  accountrecovery_note: '提示：',
  accountrecovery_tips: '帳號刪除恢復僅在申請刪除的凍結期間有效。',
  accountrecovery_Submitted2:
    '帳號刪除恢復申請已經提交，稍後您角色對應的帳號刪除申請將被取消。',
  accountrecovery_Failed: '提交失敗',
  accountrecovery_Failed_1: '申請的帳號目前處於正常狀態，可以正常登錄遊戲。',
  accountrecovery_Failed_2: '角色資訊無法查詢，請重新輸入。',
  accountrecovery_success: '帳號恢復成功',
  account_normal: '帳號狀態正常，無需恢復',
  account_unablerestore: '帳號已被註銷，無法恢復',
  accountrecovery_roleHolder: '請輸入角色名稱',
  accountrecovery_headerTitle: '帳號刪除凍結恢復',
  guideTitle:
    'Your purchase is not successful. Please contact our customer service.',
  accountFix: '帳號修復',
  inputAccount: '請輸入您需要修復的帳號名稱',
  applyForAccountFix: '申請帳號修復',
  nonEnterItem:
    '您還沒填寫的項有：註冊時間，常用設備號，常用手機型號，護照或身分證號，聯繫郵箱；請先填寫',
  resetOT: '重置已超時，請重新提交審核',
  addOT: '補充資料已超時，請重新提交審核',
  errorPwd: '密碼必須為6-20位字符，包括字母、數字、"."、"_"、"@"',
  verifyAccount: '缺少用戶賬號信息，請重新驗證',
  selectRegisterTime: '請選擇註冊時間',
  enterBindEmail: '請正確填寫已經綁定的郵箱',
  enterUsedPhoneType: '請填寫常用手機型號',
  enterIdfaGpid: '請填寫常用設備號',
  enterContactEmail: '聯繫郵箱格式不正確，請重新填寫',
  confirmTermsPrivacy: '請同意服務條款和隱私策略',
  enterRechargeRemark: '請輸入儲值記錄',
  uploadImg: '請提供清晰完整的身分證掃描件，大小不超過2M',
  selectIDType: '請選擇身分證類型',
  enterIDNum: '請輸入護照號碼或身分證號碼',
  enterIP: '請輸入註冊所在IP',
  enterQueryNum: '請輸入查詢號',
  enterQueryPwd: '請輸入查詢密碼',
  errorQueryItem: '查詢號或查詢密碼有誤，請重新輸入',
  enterPassword: '請輸入新密碼',
  enterPasswordAgain: '請再輸入新密碼',
  enterPasswordNonSame: '兩次密碼不匹配',
  enterEmail: '請輸入郵箱地址',
  sendSuccess: '郵件已經發送成功',
  enterCode: '請輸入驗證碼',
  errorCode: '輸入的驗證碼錯誤',
  selectQuest: '請選擇安全問題',
  enterAnswer: '請輸入答案',
  selectDifferQuest: '請選擇三個安全問題，并回答',
  addSuccess: '資料補充成功',
  picFormt: '圖檔格式須為JPG、PNG或GIF格式',
  countdownBefore: '重置信息有效期：',
  countdownAfter: '（當時間變為00:00:00時，連結將會失效，請重新提交帳號修復）',
  uploadDone: '上傳成功',
  uploadFail: '上傳失敗',
  applySuccess: '申請成功',
  applyFailed: '申請失敗',
  resetQuestAlterFailed: '安全問題修改失敗',
  resetQuestError: '數據輸入有誤',
  resetQuestNone: '未查詢到訂單',
  resetQuestAltered: '已經修改過安全問題',
  illegalOperation: '非法操作',
  queryNotExist: '查詢號不存在',
  queryPasswordError: '查詢密碼錯誤',
  auditing: '審核中',
  notPass: '不通過',
  suppleInformation: '補充資料',
  suppleInformationUnHandle: '已補充資料，客服未處理',
  suppleInformationTimeout: '資料補充超時',
  repairedAccountSuccess: '帳號修復已經完成',
  repairedAccountLost: '帳號修復操作，已經失效',
  loginStateNone: '未登入或者session已經失效',
  repairedAccountTimeout: '帳號修復時間已經超時',
  changePasswordSucc: '密碼修改成功',
  emailSendFailed: '郵件發送失敗',
  emailSendLimit: '該郵箱今日發送驗證碼次數已達上限',
  repairedAccountTimeout2: '非法操作帳號修復時間已經超時',
  emailCodeSended: '郵件驗證碼已經發出',
  alterSuccess: '修改成功',
  questionAlterSuccess: '安全問題修改成功',
  username: '請輸入帳號名稱',
  code: '請輸入驗證碼',
  selectServiceType: '請選擇服務類型',
  submitForm: '通過提交表單的方式來修復您的帳號',
  apply: '申請修復',
  reviewApplicationStatus: '修復進度查詢',
  instantReviewOfTheStatus: '實時查看帳號修復的進度',
  reviewStatus: '查詢進度',
  backToLogin: '返回登入頁',
  previous: '上一步',
  applyDesc:
    '以下資料請盡量保持完整，以便我們能夠為您迅速解決問題，*為必填項，如果帳號未設置此資料，請填寫無。',
  additionalServices: '附加服務',
  resetSecurityEmail: '重置安全郵箱',
  resetSecurityQuest: '重置安全問題',
  registrationDate: '註冊時間',
  month: '月',
  year: '年',
  emailBound: '請補充已綁定的郵箱',
  modelNumber: '補充常用手機型號；',
  deviceName: '請補充常用手機型號',
  provideRecharge:
    '請您提供詳細、完整的儲值記錄，包括儲值的方式、時間、金額以及相關的訂單號或交易序號，以便我們為您核查。',
  selectCountry: '選擇地區',
  passportID: '護照或身份證',
  upload: '上傳',
  del: '刪除',
  pleaseUpload: '請提供清晰完整的身分證掃描件，大小不超過20M',
  uploadAgain: '重新上傳',
  enterDesc: '如有其他可證明帳號歸屬的內容，請在這裡填寫',
  contactEmail: '聯繫郵箱',
  applyNoteAttr: '溫馨提示：',
  applyNoteDate:
    '為了能夠及時收到本次申訴的進度、結果，請您提供可接收信息的郵箱地址',
  agree: '我已同意',
  UJOYTerms: 'UJOY服務條款',
  privacy: '隱私政策',
  reviewStatusOfAccountFix: '修復進度查詢',
  enterReviewID: '請輸入查詢號',
  enterReviewPwd: '請輸入查詢密碼',
  review: '查詢',
  reviewNoteAttr: '溫馨提示：',
  reviewNoteData:
    '如果您不小心遺失查詢號、查詢密碼，可在您提供的聯繫郵箱中查看',
  haveResetInfo: '您已經重新設置您的信息！',
  resetProfile: '重置您的信息',
  desc: '恭喜您，審核通過！請重新設置您的信息。',
  changePwd: '修改密碼',
  resetPwd: '重新設置一個密碼',
  reset: '修改',
  enterNewPwd: '請輸入新密碼',
  confirmNewPwd: '請重複新密碼',
  successResetPwd: '您的新密碼已設置成功',
  bindSecurityEmail: '綁定安全郵箱',
  resetPwdDesc: '用於忘記密碼或者帳號被盜時快速重置密碼',
  bindCommon: '綁定',
  sendCommon: '發送',
  enterVcode: '請輸入收到的驗證碼',
  successResetEmail: '您的安全郵箱已重置成功',
  resetQuest: '重置安全問題',
  resetQuestDesc: '用於忘記密碼或者帳號被盜時快速重置密碼',
  successResetQuest: '您的安全問題已重置成功',
  hide: '收起',
  addRegisterTime: '補充註冊時間；',
  modelNum: '請補充常用設備號：IDFA/GPID',
  registrationIP: '補充帳號註冊所在IP；',
  addRechargeRecord: '補充儲值記錄；',
  serviceReply: '客服回復：',
  addDataLimitTime: '補充資料有效期：',
  addMoreInfo: '補充更多資料',
  applicationSubmit: '申請提交成功',
  underReviewStatus:
    '您的資料目前正在審核中，我們將在一個工作日內給您答復，您也可以通過以下方式查看進度：',
  reviewID: '查詢號：',
  reviePwd: '查詢密碼：',
  enterReviewIDNPwd:
    '在帳號修復進度查詢頁面上，輸入查詢號、查詢密碼即可查看當前處理進度',
  homepage: '返回首頁',
  checkEmailAttr: '溫馨提示：',
  checkEmailData:
    '如果您不小心遺失查詢號、查詢密碼，可在您提供的聯繫郵箱中查看',
  underReview: '資料審核中',
  underReviewReply: '資料正在審核中，請您耐心等候，我們會盡快給您答復！',
  failed: '審核未通過',
  reason:
    '原因：由於您所提供的###因此審核未能通過，請您提供正確信息，相關人員會盡快為您進行處理，感謝您的配合，謝謝！',
  underReviewAdd:
    '資料正在審核中，因部分資料不一致或者為空，請您提供更多的資料以便我們為您核實！',
  addInfoRequired: '需要補充資料：',
  dateForAddInfo: '補充資料有效期：',
  addInfo: '補充資料',
  addInfoSubmit: '補充資料已提交，請等候審核！',
  hasBeenRepaired: '帳號修復已經完成',
  opExpired: '帳號修復操作，已經失效',
  approved: '審核通過',
  haveSubmitted: '您已經補充過資料了',
  sessionExpired: '您還未登入或者session已失效',
  submitted: '補充成功',
  addItemRegisterDate: '補充綁定郵箱；',
  addItemDeviceNumber: '補充常用設備號；',
  reasonItemPwd: '身分證號碼不符；',
  addItemIDPhoto: '補充清晰有效證件；',
  idfaTitle: '如何在蘋果手機查找IDFA以及安卓手機ID？',
  idfaSubTitle1: '一、如何查找IDFA',
  idfaSubTitle1Desc1: '1、在appsotre下載【<em>MyIDFA</em>】',
  idfaSubTitle1Desc2:
    '2、下載完成後進入<em>APP</em>即可看到本機的<em>IDFA碼</em>。',
  idfaSubTitle2: '二、如何查找穀歌ID',
  idfaSubTitle2Desc1: '1、打開手機【<em>設定</em>】功能；',
  idfaSubTitle2Desc2:
    '2、在【<em>設定</em>】內找到【<em>帳戶</em>】或【<em>帳戶與同步處理</em>】中的【<em>Google</em>】，點擊進入',
  idfaSubTitle2Desc3:
    '3、然後再點擊【<em>廣告</em>】，即可看到對應的<em>ID</em>（如下圖所示）。',
  uploadIDCard: '請提供清晰完整的身分證掃描件，大小不超過2M',
  uploadTipsBefore: '請上傳大小',
  uploadTipsAfter: 'M以下的圖檔',
  submitError: '異常錯誤，例如身分證號碼未填寫、用戶帳號錯誤都歸為異常錯誤',
  applyLimitError: '超過當日申請限制次數',
  applyDisabled: '提交申請冷卻中（只允許10分鐘提交一次）',
  inputDataError: '數據未填寫完整',
  dataException: '數據異常',
  picSizeLimit: '圖檔大小限制為5M',
  picTypeLimit: '只能上傳JPG，PNG，GIF圖檔',
  picNull: '圖片為空',
  alteredPassword: '已經修改過密碼',
  inputError: '輸入錯誤',
  pwdChangefailed: '密碼修改失敗',
  sendEmailCodeDisabled: '郵箱驗證碼發送冷卻中',
  alteredEmail: '已經修改過郵箱',
  inputEmailError: '郵箱輸入錯誤',
  operationFailed: '操作失敗',
  codeNull: '您還未輸入驗證碼',
  findPwd: '密碼找回',
  findAccountAndPwd: '找回帳號與密碼',
  usualDeviceNum: '常用設備號：IDFA/GPID',
  usualPhoneNum: '常用手機型號',
  registerTimeError: '註冊時間不符；',
  bindEMailError: '綁定郵箱不符；',
  rechargeRecordError: '儲值記錄不符；',
  registerIPError: '帳號註冊IP地址不符；',
  deviceNumError: '常用設備號不符；',
  deviceModelError: '常用手機型號不符；',
  confirmTerms: '請同意服務條款',
  applyFixAccount: '若上述管道無法驗證，您可以申請<span>帳號修復</span>',
  findPwdByFixAccount:
    '該帳號沒有設定郵箱與密保，您可以通過帳號修復功能進行密碼找回',
  connectFail: 'Disconnected from Google Services, please try again',
  h5_favour_has_gift: '收藏遊戲至瀏覽器方便下次再來～您已獲得過獎勵哦～',
  h5_favour_get_gift: '收藏遊戲至瀏覽器方便下次再來，獎勵已發送至您的郵箱～',
  h5_get_gift_fault: '領取失敗，請稍後再試或前往遊戲內聯繫客服處理',
  h5_favour_please_select: '請先選擇伺服器/角色',
  h5_favour_login_get: '請先進入遊戲再收藏，確保獎勵發放至您的郵箱哦～',
  h5_favour_tip: '收藏遊戲至瀏覽器方便下次再來～',
  h5_favour_select_serve: '請選擇伺服器',
  h5_favour_select_role: '請選擇角色',
  store_product_paytype_error:
    '您選擇的商品在當前渠道無法進行購買，請更換支付渠道進行購買',
  SwitchWithThirdWay: '切換${type}登入',
  moreGame: '更多遊戲',
  serviceTitle: '客服工单',
  h5_download_login: '請先進入遊戲再下載，確保獎勵發放至您的郵箱哦～',
  h5_download_tips: 'Please start the game from the client.',
  h5_download_repeat_get: '保存到桌面方便下次再來～您已獲得過獎勵哦～',
  h5_download_succ: '保存到桌面方便下次再來，獎勵已發送至您的郵箱～',
  h5_download_repeat_role: '當前角色已被綁定',
  currentLoginAccount: '當前登錄帳號：',
  fb_canvas_fullscreen: '全屏模式',
  fb_canvas_website: '官網',
  fb_canvas_like_share: '點讚分享',
  fb_canvas_service: '客服',
  fb_canvas_login_fail: '登錄失敗',
  fb_canvas_pay_return: '您取消了本次交易',
  fb_canvas_root_tip: '請先進行Facebook的授權登錄',
  h5_popup_title: '付款方式',
  h5_popup_submit: '付款',
  h5_popup_last_used: '上次使用',
  h5_popup_quit_tips: '是否取消付款？',
  h5_popup_quit_check: '是',
  h5_popup_quit_cancel: '否',
  h5_popup_currency_sign: '元',
  h5_popup_product_empty: '未獲取到所選商品信息，請刷新頁面',
  h5_popup_server_empty: '未獲取到服務器列表，請刷新頁面',
  aboutRelevanceAccount: '關於關聯帳戶',
  selectLoginType: '請選擇登錄方式',
  touristDescription:
    'If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.',
  touristSuggest:
    'If you already have an account, you can log in as a guest and then tap the "Switch Account" option in the user center. From there, you can log in using a previously bound social media account.',
  h5_tourist_remenber: '14天內記住我的密碼',
  account_czsm1:
    '1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；',
  account_czsm2: '2、引き継ぐ時のパスワードを登録してください。',
  account_czsm3: '3、セキュリティ保護のため、',
  account_wzfdmm: '大文字と小文字を区別して、6-16文字のパスワードをご入力',
  account_qzcsrmm: '再度パスワードをご入力',
  account_fxyjm: '引き継ぎコード発行',
  account_yjmsm1:
    '1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。',
  account_yjmsm2: '2、引き継ぎナンバーに使用期限はございません。',
  account_yjmsm3:
    '3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。',
  account_yjmsm4:
    '4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。',
  account_fz: 'コピー',
  account_cxfx: '新規で発行する',
  account_czsm4: 'アカウントを連携',
  account_czsm5: 'してください。',
  account_yjm: '引き継ぎコード',
  account_16wzzj: 'パスワードの長さは6～16文字にする',
  account_qsrzqdyjmhmm: '正しい引き継ぎコードとパスワードを入力してください。',
  account_yj: '引き継ぎ',
  accoun_lcsrdmmbyz: 'パスワードの両回の入力は一致しない',
  deleteaccount_step3_1: '，取消帳號刪除的請求，您是否要取消此次申請？',
  account_syyjm:
    '1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。',
  account_yjmznsyyc:
    '2. 引き継ぎコードは一度しか使えず、再発行することができます。',
  account_sryjm: '引き継ぎコードを入力',
  account_srmm: 'パスワードを入力',
  h5_header_gift: '禮包',
  h5_award_popup_type: '獎勵',
  h5_award_popup_content: '物品',
  h5_award_popup_code: '禮包兌換碼',
  h5_favour_gift_name: '收藏禮包',
  h5_download_gift_name: '下載禮包',
  h5_award_popup_exchange_way: '兌換地址：遊戲主界面右下方→更多→禮包碼',
  h5_succ_get_gift: '恭喜獲得禮包兌換碼',
  h5_exchange_info_title: '兌換說明',
  h5_exchange_info_1: '兌換地址：遊戲主界面右下方→更多→禮包碼',
  h5_exchange_info_2: '一個帳號只能兌換一次下載禮包',
  h5_check_gift: '查詢獎勵',
  account_delete_scdqzh: '你確定要刪除當前帳號及遊戲內所有信息嗎？',
  account_delete_fwq: '服務器',
  account_delete_zhm: '角色名',
  account_delete_jshflj: '角色恢复鏈接',
  account_delete_qzyzmdxx: '（请注意字母大小写）',
  account_delete_jtbcysxx: '建议截图保存以上信息嚟账号搵翻！！！！',
  deleteaccount_step3_2:
    '14天后您的帳號會被系統自動刪除並且沒有任何方式可以進行恢復，您帳號內的所有資料將不再存在與保存。\n\n在申請後的14天內，您依舊可以通過訪問',
  h5_guest_login: 'Guest',
  h5_click_copy: '',
  questionnaire_btn: '問卷調查',
  h5_header_store_text: '儲值',
  h5_header_home_text: '主頁',
  h5_check_gift_list_text: '查看獎勵',
  yourServer: '您的伺服器',
  allServer: '全部伺服器',
  h5_header_screen: '全螢幕',
  h5_verticalTip: '請用橫屏方式進行操作',
  h5_third_party_login_tips:
    'If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.',
  webStoreUidTitle: '',
  webStoreUidTips: '',
  webStoreUidGuide: '',
  webStoreUidInputt: '',
  feedbackTips: '',
  recentPlay: '最近在玩',
  moreGames: '更多遊戲',
  previousSelect: '上次選擇',
  payAgainBtn: '再儲一次',
  packageTypeName: '禮包',
  coinTypeName: '儲值',
  cardTypeName: '月卡',
  orderNormal: '默認排序',
  orderPriceUp: '按價格升序',
  orderPriceDown: '按價格降序',
  returnSelectRole: '返回重新選擇',
  jiamaInfo:
    '加碼元寶/鑽石說明：\n加碼元寶/鑽石=付款金額*遊戲 元寶/鑽石 比例*加碼比例\n*注意：加碼的元寶/鑽石，不參與遊戲內儲值活動的計算，也不計入VIP經驗\n*部分遊戲為全球發行遊戲，付款金額將以美金計算，如有問題請聯繫客服',
  lastSelectTag: '上次選擇',
  onestore_subscribe_manage: 'Manage',
  onestore_subscribe_entrance: 'OneStore Subscription',
  onestore_subscribe_has_expire: 'Expired',
  onestore_subscribe_expire_time: 'Expire on ${month}/${day}/${year}',
  onestore_subscribe_privacy: 'About Subscription and Privacy',
  onestore_subscribe_cancel_subscribe: 'Cancel Subscription',
  onestore_subscribe_info_title: 'Subscription Info',
  onestore_subscribe_option_title: 'Options',
  onestore_subscribe_do_not_subscribe: 'No subscribed items.',
  onestore_subscribe_get_role_fail:
    'Failed to subscribe. Please open this page again in the game.',
  onestore_subscribe_later: 'Later',
  onestore_subscribe_confirm: 'Confirm',
  onestore_subscribe_confirm_cancel: 'Confirm Cancellation',
  onestore_subscribe_popup_tip:
    'If you cancel now, you can still access your subscription until ${month}/${day}/${year}.',
  onestore_subscribe_detail_tip:
    'Subscribed item will be renewed on ${month}/${day}/${year} (Price: ${prices}/month). Subscription can be canceled 1 day before it expires.',
  onestore_subscribe_expired_tip:
    'Please subscribe the expired item from the in-game Mall/Shop',
  onestore_subscribe_goon_sub: 'Renew on ${month}/${day}/${year}',
  onestore_subscribe_has_cancel_tip1:
    'Subscription canceled. You can still access your subscription until ${month}/${day}/${year}.',
  onestore_subscribe_has_cancel_tip2:
    'If you wish to subscribe again. Please do so in the in-game Mall/Shop.',
  onestore_subscribe_cancel_fail:
    'Failed to cancel subscription. Please try again later.',
  onestore_subscribe_cancel_fail_title: 'Cancel Subscription',
  apple_deleteaccount: '帳號刪除',
  apple_deleteaccount_title: '帳號刪除申請',
  apple_deleteaccount_step1_1: '請仔細閱讀以下內容：',
  apple_deleteaccount_step1_2: '在您執行帳號刪除後，您的帳號會被凍結14日。',
  apple_deleteaccount_step1_3:
    '14日後若您不取消帳號刪除，我們會為您<span class="highlight">永久刪除</span>該帳號，永久刪除後，您無法使用該帳號登錄遊戲，所有資料全部清除且無法恢復。',
  apple_deleteaccount_step1_4:
    '如需解綁對應已綁定的社交網路帳號，請提前聯繫客服解綁完畢再進行帳號刪除。否則帳號刪除後，您對應綁定的社交網路帳號也無法登錄。',
  apple_deleteaccount_step1_5:
    '<span class="highlight">如需退款也請在執行刪除前聯繫客服處理</span>，在執行帳號刪除前，請確定您的遊戲內資產已處理完畢。',
  apple_deleteaccount_step1_6:
    '在凍結期間，您可以通過以下連結取消帳號刪除的請求，請提前複製保存該位址以便找回。',
  apple_deleteaccount_step2_1:
    '您遊戲內資產是否已經處理完畢？如未處理完畢，請聯繫客服處理後再申請帳號刪除。',
  apple_deleteaccount_step2_2:
    '請保存您的伺服器與角色資訊，這是您恢復帳號的唯一憑證：',
  apple_deleteaccount_step2_3: '請在輸入框中輸入“Delete”來完成刪除操作',
  apple_deleteaccount_step3_1: '您的帳號刪除申請已提交，以下帳號已被凍結：',
  apple_deleteaccount_step3_2:
    '凍結時間14天，若未收到您的取消刪除帳號請求，我們會永久刪除該帳號。',
  apple_deleteaccount_step3_3: '在14天內，您仍舊可以訪問以下位址取消刪除帳號',
  apple_deleteaccount_step4_1:
    'You have deleted your old account. Please log in with a new account next time.',
  apple_deleteaccount_agree: '我已閱讀並同意以上內容',
  apple_deleteaccount_server: '伺服器',
  apple_deleteaccount_roleName: '角色名',
  copyLink: '複製連結',
  copyTextAndImg: '請複製或截圖保存',
  copyLinkAndRoleInfo: '複製連結和角色名',
  hasCopy: '已複製至剪貼板',
  quickcard_tips:
    '信用卡資訊已加密儲存並受WorldPay保護，此信息僅用於優化儲值體驗。',
  quickcard_use_new_card: '使用新的信用卡',
  edit: '編輯',
  save: '保存',
  quickcard_confirm_delete: '確認刪除',
  quickcard_popup_tip:
    '刪除後，若您希望再次使用該信用卡，請選擇“使用新的信用卡”。',
  quickcard_result_tip_one:
    '如您在剛才的支付頁面中選擇了儲存卡號，我們會收集您的信用卡數據以加密形式進行儲存 (**** **** **** 1234）。',
  quickcard_result_tip_two:
    '我們儲存加密的資訊只是為了方便您的儲值體驗，您不必在下次購買時輸入卡號。',
  quickcard_learn_more: '瞭解更多細節》',
  quickcard_info_title: '存儲憑據說明',
  quickcard_info_tip_one:
    '為了更好地保護客戶數據安全， Visa 和 Mastercard 引入了新的“存儲憑據”技術，並規範化了存儲憑據和相關的交易。',
  quickcard_info_tip_two:
    '當您在我們的網站上購物時，我們會以加密版本收集您的信用卡數據(1234 **** **** 1234）。我們將保留此加密數據4 年，如有任何相關變更，我們將在我們的網站上更新用戶條款與隱私政策。我們儲存加密信用卡數據只是為了優化您的支付體驗，您不必在下次購買時輸入卡號。',
  search_product: '搜索商品名',
  search_price: '搜索價格',
  price: '價格',
  product_no_found: '抱歉，我們沒有找到符合的商品名',
  price_no_found: '抱歉，我們沒有找到符合的價格',
  search_no_found: '抱歉，我們沒有找到符合的商品名/價格',
  product: '商品名稱',
  store_tag_hot: 'HOT',
  store_tag_discount: 'Discount',
  store_tag_double: 'Double',
  store_tag_treble: 'Treble',
  store_tag_sale: 'SALE',
  store_tag_top_seller: 'TOP SELLER',
  store_tag_off_10: '10%OFF',
  store_tag_off_20: '20%OFF',
  store_tag_off_30: '30%OFF',
  store_tag_off_40: '40%OFF',
  store_tag_off_50: '50%OFF',
  store_tag_off_60: '60%OFF',
  store_tag_off_70: '70%OFF',
  store_tag_off_80: '80%OFF',
  store_tag_off_90: '90%OFF',
  store_tag_event: 'Event',
  store_tag_daily: 'Daily',
  store_tag_weekly: 'Weekly',
  store_tag_monthly: 'Monthly',
  subscriptionTypeName: '訂閱',
  useDoubleSend: '使用禮包翻倍券?',
  doubleSendInfo:
    '由於您在本次購買時，使用了禮包翻倍券，有部分物品可以獲得雙倍，已在郵件最後單獨列出！',
  storeRoleTitle: '請選擇要儲值的角色',
  storeSocialLogin: '使用社交帳號登錄',
  storeAccountIdLogin: '使用帳號ID登錄',
  storeInputId: 'Enter account ID',
  storeSearch: '查詢',
  storeSelectProductTitle: '請選擇要購買的道具',
  storeInputNameSearch: '輸入商品名進行搜索',
  storeInputPriceSearch: '輸入商品價格進行搜索',
  storeNoFindProduct: '找不到商品，請重新搜索。',
  storePriceUp: '按價格昇冪',
  storePriceDown: '按價格降冪',
  storeLookDetail: '查看詳情',
  storeChangeProduct: '更換商品',
  storeWelcome: '歡迎',
  storeLookMore: '查看更多',
  storeHasSelect: '已選商品',
  storeTotal: '共',
  storeExtra: '額外贈送',
  storeProductDetail: '商品詳情',
  storeUidGuideStep1: '點擊「設置」-「更多」-「帳戶」',
  storeUidGuideStep2: '輸入這裡的「帳號ID」即可儲值',
  storeSelectAndLook: '請先選擇角色以查看商品',
  storeSwitchWay: '切換登錄方式',
  type1: '每日特惠',
  type2: '英雄',
  type3: '戰鬥裝備',
  type4: '',
  type5: '晶片',
  type6: '生化人',
  type7: '資源',
  type8: '建造加速',
  type9: '稀缺商品',
  type10: '聯盟',
  type11: '鑽石',
  type12: '元件',
  type13: '魔方',
  type14: '',
  type15: '納米武器',
  type16: '終極大獎',
  type17: '',
  type9999: '限量供應',
  type10000: '福利中心',
  type10001: '節日活動',
  typeother: '其他商品',
  switchChar: '切換角色',
  howToFindUid: '如何找到我的帳號ID？',
  choosePayWay: '請選擇支付方式',
  new_apple_deleteaccount_stepsub_title: '取消自動續訂訂閱',
  new_apple_deleteaccount_stepsub_1:
    '系統檢測到您的帳號有自動續訂訂閱的付費專案，為避免您在刪除帳號後繼續扣費，建議先取消訂閱後再進行帳號刪除。',
  new_apple_deleteaccount_stepsub_2: '去取消自動續訂訂閱',
  new_apple_deleteaccount_stepsub_later: '稍後刪除',
  new_apple_deleteaccount_stepsub_now: '立即刪除',
  new_apple_deleteaccount_title: '帳號刪除申請',
  new_apple_deleteaccount_step1_1: '請仔細閱讀以下內容：',
  new_apple_deleteaccount_step1_2:
    '在您執行帳號刪除後，我們會為您<span class="highlight">永久刪除</span>該帳號，永久刪除後，您無法使用該帳號登錄遊戲，您的帳號關聯<span class="highlight">用戶資料</span>（包括但不限於遊戲貨幣，道具等資料）將被立即清除且無法恢復。 （如您所在國家或地區有相關法律規定要求，則不在此列）',
  new_apple_deleteaccount_step1_3:
    '如需解綁對應已綁定的社交網路帳號，請提前聯繫客服解綁完畢再進行帳號刪除。否則帳號刪除後，您對應綁定的社交網路帳號也無法登錄。',
  new_apple_deleteaccount_step1_4:
    '<span class="highlight">如需退款也請在執行刪除前聯繫客服處理</span>，在執行帳號刪除前，請確定您的遊戲內資產已處理完畢。',
  new_apple_deleteaccount_step2_1:
    '您遊戲內資產是否已經處理完畢？如未處理完畢，請聯繫客服處理後再申請帳號刪除。',
  new_apple_deleteaccount_step2_2:
    '請在輸入框中輸入“Delete”來完成刪除操作。提交申請後，您的帳號將無法恢復。',
  new_apple_deleteaccount_step2_3: '請在輸入框中輸入“Delete”來完成刪除操作',
  new_apple_deleteaccount_step3_1:
    '您的帳號刪除申請已提交，以下帳號及對應使用者資料已被徹底刪除，不可恢復：',
  new_apple_deleteaccount_step3_2: '如您仍需登錄遊戲，請重新註冊帳號。',
  new_apple_deleteaccount_step4_1: '您已刪除舊帳號，下次進入將使用新帳號登錄',
  currencyTypeName: '代幣',
  has_select_product: '已選擇商品：',
  n_product: '${n}個商品',
  look_detail_product: '查看全部',
  limit_buy_product: '該商品限購${n}件',
  limit_order: '單筆訂單最多支援${n}件商品',
  limit_order_remove_tip: '訂單中包含無法購買的限購商品，是否移出購物車？',
  paytype_limit:
    '部分商品不支援該支付方式，請選擇其他支付方式 或 嘗試單獨購買商品',
  check_remove_cart: '是否移出購物車',
  remove_cart: '移出',
  confirm_product: '確認商品',
  select_paytype: '選擇支付方式',
  cart_is_empty_tip: '購物車為空，請先選擇商品',
  thirty_tip: '若30分鐘後仍未收到商品，請聯繫客服。',
  total_n_product: '共 ${n}個商品',
  look_detail_of_cart: '查看詳細',
  order_detail: '儲值商品訂單記錄',
  total_detail: '數量：',
  add_to_cart: '添加購物車',
  back_to_select: '返回重新選擇',
  fail_and_later: '商品資訊錯誤，請稍候再試',
  nextStep: '下一步',
  pnsGameName: 'Puzzles & Survival',
  enterOfficial: '進入官網',
  visitorLogin: '遊客登錄',
  tokenLogin: '動態驗證',
  fbLogin: 'Facebook登錄',
  googleLogin: 'Google登錄',
  twitterLogin: 'Twitter登錄',
  vkLogin: 'VK登錄',
  agreementTextStart: '登錄遊戲即代表您已完整閱讀並同意 帳號條款 和 隱私協議',
  userCenter: '用戶中心',
  welcomeBack: '歡迎回來',
  continueGame: '繼續遊戲',
  officialPay: '官方儲值中心',
  changeAccount: '切換帳號',
  back: '返回',
  tokenKey: '動態驗證',
  inputUid: '請輸入UID',
  inputToken: '請輸入動態驗證',
  inputCkCode: '請輸入驗證碼',
  enterGame: '進入遊戲',
  tokenTip: '使用動態驗證保護您的帳號安全',
  howToGetToken: '如何獲取我的動態驗證？',
  getStep1: 'Step1:點擊設置-帳戶-用戶中心',
  getStep2: 'Step2:點擊動態驗證',
  getStep3: 'Step3:複製並輸入您的UID和動態驗證',
  copy: '複製',
  lastRefresh: '下次刷新：',
  second: '秒',
  immediatelyRefresh: '立即刷新',
  frequently: '頻繁過於操作，請稍候再試',
  loginFail: '登錄失敗，驗證碼錯誤',
  tokenIntro: '動態驗證使用說明：',
  tokenIntro1: '（1）動態驗證自刷新起120秒內有效，可用於保護您的帳號安全。',
  tokenIntro2:
    '（2）官方人員不會要求您提供動態驗證，請注意不要洩漏您的動態驗證給其他人。',
  nextStep1: '下一步',
  couponCanUse: '可用優惠券',
  couponCanNotUse: '不可用優惠券',
  couponHasNoCoupon: '暫無優惠券',
  couponUseTip: '*每筆訂單限用一張',
  couponValidTime: '有效時間',
  couponFuilCanUse: '滿 ${price} ${currency} 可用',
  couponNoLimit: '無使用門檻',
  couponAllProductCanUse: '所有商品可用',
  couponPartProductCanUse: '部分商品可用',
  couponPartPaytypeCanUse: '部分支付管道可用',
  couponOnlyCoinCanUse: '僅限遊戲幣商品可用',
  couponOnlyDiamondCanUse: '僅限鑽石商品可用',
  couponOnlyPackageCanUse: '僅限禮包商品可用',
  couponOnlySubCanUse: '僅限訂閱商品可用',
  couponOnlyDaibiCanUse: '僅限代金幣商品可用',
  couponMaxDiscount: '最高可優惠 ${price} ${currency}',
  couponHasUsed: '已被使用',
  couponReductionType: '滿減券',
  couponDiscountType: '折扣券',
  couponUseNow: '立即使用',
  couponHasNoSelect: '未選中優惠券',
  couponHasSelectQuan: '已選擇',
  couponSubmitTip: '*提交訂單後即消耗優惠券',
  couponCanUseQuan: '可用優惠券',
  couponOrderTotal: '訂單金額',
  couponHasDiscount: '已優惠',
  couponPayTotal: '支付金額',
  couponCancel: '取消',
  couponConfirm: '確認',
  uidLoginName: '動態驗證登錄',
  uidToken: '動態驗證',
  uidInputUid: '請輸入UID',
  uidInputToken: '請輸入動態驗證',
  uidInputCode: '請輸入驗證碼',
  uidTipTitle: '使用動態驗證保護您的帳號安全',
  uidTipHowToGet: '如何獲取我的動態驗證？',
  uidTipStep1: 'Step1:點擊設置-帳戶-用戶中心',
  uidTipStep2: 'Step2:點擊動態驗證',
  uidTipstep3: 'Step3:複製並輸入您的UID和動態驗證',
  uidTipIntro1: '（1）動態驗證自刷新起60秒內有效，可用於保護您的帳號安全。',
  uidTipIntro2:
    '（2）官方人員不會要求您提供動態驗證，請注意不要洩漏您的動態驗證給其他人。',
  couponMyQuan: '我的優惠券',
  couponSelectPaytypeTip: '選定支付管道後確認優惠資訊',
  couponSelectCouponTip: '選擇優惠券後查看優惠價格',
  couponValidQuanTip: '（${num}張優惠券可用）',
  couponLookCart: '查看購物車',
  couponUnfoldCart: '收起購物車',
  couponCoupon: '優惠券',
  couponNoUse: '未使用',
  couponSelect: '選擇優惠券',
  couponSureUse: '確認使用',
  couponReturn: '返回',
  couponInvalidTime: '失效時間',
  couponBuyNow: '立即購買',
  couponAllType: '所有商品',
  ztmslgType1: '每日特惠',
  ztmslgType2: '英雄',
  ztmslgType3: '戰鬥裝備',
  ztmslgType4: '',
  ztmslgType5: '晶片',
  ztmslgType6: '生化人',
  ztmslgType7: '資源',
  ztmslgType8: '建造加速',
  ztmslgType9: '稀缺商品',
  ztmslgType10: '聯盟',
  ztmslgType11: '鑽石',
  ztmslgType12: '元件',
  ztmslgType13: '魔方',
  ztmslgType14: '',
  ztmslgType15: '納米武器',
  ztmslgType16: '終極大獎',
  ztmslgType17: '晶核',
  ztmslgType9999: '限量供應',
  ztmslgType10000: '福利中心',
  ztmslgType10001: '節日活動',
  ztmslgTypeother: 'Other',
  antslgType1: '每日特惠',
  antslgType2: '特化蟻',
  antslgType3: '裝備',
  antslgType5: '基因',
  antslgType6: '蝸牛',
  antslgType7: '資源',
  antslgType8: '建造研發',
  antslgType9: '稀缺商品',
  antslgType10: '聯盟',
  antslgType11: '鑽石',
  antslgType12: '細胞',
  antslgType13: '圖騰',
  antslgType9999: '限量特供',
  antslgTypeother: 'other',
  typeall: '所有商品',
  vipHead: 'VIP積分',
  vipHead213: '大會員中心',
  vipTitle: 'VIP積分活動',
  nowLevel: '當前VIP等級：',
  myVipScore: '我的積分：',
  nextLevelNeed: '（還有${num} 積分達到 VIP ${level}）',
  ruleTitle: '活動規則：',
  ztmslgVipRule1: '1.活動時間:2022年9月22日00:00起（UTC)',
  ztmslgVipRule2: '2.參與遊戲︰ Puzzles & Survival',
  ztmslgVipRule3: '每種活動獎勵僅可領取一次,請及時領取。',
  ztmslgVipRule4: '3.“登錄送券”活動︰首次登錄儲值頁面，領取15%OFF優惠券',
  ztmslgVipRule5:
    '4.“VIP積分”活動︰官方支付頁面購買商品積分達到對應等級，即可獲得等級到達優惠券與每週專屬優惠券',
  ztmslgVipRule6: '5.各幣種積分比例請見附表1，不足1積分則不計入',
  ztmslgVipRule7: '6.如訂單使用優惠券，積分將以實際支付金額計算',
  ztmslgVipRule8: '7.積分有效期為365天，VIP等級根據當前有效積分進行變動',
  ztmslgVipRule9:
    '8.到達VIP等級即可立刻領取首次到達送券&新等級每週送券，後續每週送券於每週六0點（UTC+0）刷新',
  ztmslgVipRule10:
    '9.每週優惠券需登錄領取，如錯過不進行補發，優惠券獎勵將不定期更新',
  ztmslgVipRule11:
    '10.優惠券幣種以您最後儲值成功的訂單幣種為准，如需更換幣種請聯繫客服',
  ztmslgVipRule12: '11.VIP檔位及贈送抵扣券規則如下圖∶',
  ztmslgVipRule13: '12.本活動最終解釋權歸 Puzzles & Survival 運營團隊所有。',
  vipLevel: 'VIP等級',
  vipCondition: '達成積分條件',
  firstSend: '首次達成贈送',
  weeklySend: '每週福利送券',
  lastAllCoupon: '上一檔位全部優惠券',
  besides: '附表：',
  couponRatio: '各幣種VIP積分比例',
  backToPay: '返回儲值',
  quanGift: '優惠券福利',
  quanGiftTips: '您有一批新的優惠券，請查收',
  antslgVipRule1: '因功能煥新，原「VIP積分」活動即將下線。',
  antslgVipRule2:
    '原「VIP積分」活動所得優惠券請您及時使用，避免超出優惠券有效期限。',
  antslgVipRule3: '下線時間：2024-09-28 00:00:00(UTC)',
  antslgVipRule4: '活動下線後，您可前往大會員中心體驗更多權益：',
  antslgVipRule5:
    '完成任務獲取積分，使用積分即可兌換優惠券、遊戲道具等獎勵！還有專屬會員權益、積分抽獎等福利活動。',
  antslgVipRule6: '敬請期待。',
  dzgVipRule0: '1.活動時間:2022年9月27日00:00起（UTC)',
  dzgVipRule1: '1.參與遊戲︰ ${gameName}',
  dzgVipRule2: '每種活動獎勵僅可領取一次,請及時領取。',
  dzgVipRule3: '2.“登錄送券”活動︰首次登錄儲值頁面，領取15%OFF優惠券',
  dzgVipRule4:
    '3.“VIP積分”活動︰官方支付頁面購買商品積分達到對應等級，即可獲得等級到達優惠券與每週專屬優惠券',
  dzgVipRule5: '4.各幣種積分比例請見附表1，不足1積分則不計入',
  dzgVipRule6: '5.如訂單使用優惠券，積分將以實際支付金額計算',
  dzgVipRule7: '6.積分有效期為365天，VIP等級根據當前有效積分進行變動',
  dzgVipRule8:
    '7.到達VIP等級即可立刻領取首次到達送券&新等級每週送券，後續每週送券於每週六0點（UTC+0）刷新',
  dzgVipRule9:
    '8.每週優惠券需登錄領取，如錯過不進行補發，優惠券獎勵將不定期更新',
  dzgVipRule10:
    '9.優惠券幣種以您最後儲值成功的訂單幣種為准，如需更換幣種請聯繫客服',
  dzgVipRule11: '10.VIP檔位及贈送抵扣券規則如下圖∶',
  dzgVipRule12: '11.本活動最終解釋權歸 ${gameName} 運營團隊所有。',
  '213dzgVipRule1': '因功能煥新，原「VIP積分」活動即將下線。',
  '213dzgVipRule2':
    '原「VIP積分」活動所得優惠券請您及時使用，避免超出優惠券有效期限。',
  '213dzgVipRule3': '下線時間：2024-08-19 08:00:00 (utc)',
  '213dzgVipRule4': '活動下線後，您可前往大會員中心體驗更多權益：',
  '213dzgVipRule5':
    '完成任務獲取積分，使用積分即可兌換優惠券、遊戲道具等獎勵！還有專屬會員權益、積分抽獎等福利活動。',
  '213dzgVipRule6': '敬請期待。',
  getReward: '專屬頭像',
  unbindEntry: '帳號綁定/解綁',
  unbindApply: '申請解綁',
  unbindConfirmTitle: '是否確認解綁',
  unbindConfirmTip: '您確定解綁第三方帳號？有可能導致帳號進度丟失',
  unbindConfirm: '是，繼續解綁',
  unbindExit: '否，退出',
  unbindSucc: '解綁成功',
  unbindFail: '解綁失敗，請聯繫客服',
  unbindServiceTitle: '請申請人工解綁',
  unbindContact: '連絡人工客服',
  unbindServiceTip: '您不符合自動解綁條件，請連絡人工客服申請解綁',
  antslgType15: '傳承之力',
  shareEventTitle: '邀好友 享好禮',
  shareRule: '活動規則',
  awardBag: '我的獎勵背包',
  initiatorText: '我是發起人',
  inviteeText: '我是受邀人',
  createCode: '創建邀請碼',
  createCodeTip: '點擊生成專屬邀請碼',
  createLinkTip: '點擊生成專屬邀請連結',
  copyText: '複製',
  shareCode: '分享邀請碼',
  twShare: '',
  fbShare: '',
  dcShare: '',
  seeAward: '查看獎勵',
  seeAwardTip:
    '請前往“<span class="see-light">VIP積分</span>”-“<span class="see-light">我的優惠劵</span>”中進行查看並使用',
  inviteReward: '邀請獎勵',
  inviteRewardTip: '受邀人累儲檔位不重置',
  overweightReward: '加碼獎勵',
  resetTip: '每月最後一天00：00重置（UTC+0）',
  rewardText1: '受邀人累儲達9.99USD',
  rewardText2: '受邀人累儲達49.99USD',
  rewardText3: '受邀人累儲達99.99USD',
  rewardText4: '每邀請5人，獲得一張12%OFF優惠劵！',
  rewardText5: '受邀人總儲值數達1000USD，獲得一張15%OFF優惠劵！',
  invitationList: '邀請一覽',
  refresh: '刷新',
  invitedTotal: '總計已邀請：${total} 人',
  storedTotal: '總計已累儲：${total} USD',
  people: '',
  invitedPeople: '受邀人',
  invitedTime: '受邀時間',
  got: '已達成',
  get: '未達成',
  overlay: '可疊加',
  couponText: '優惠劵',
  personalReward: '個人儲值獎勵',
  personalRewardText1: '個人累儲達9.99USD',
  personalRewardText2: '個人累儲達49.99USD',
  personalRewardText3: '個人累儲達99.99USD',
  inputCode: '輸入邀請碼',
  bindCode: '綁定邀請碼',
  bindSucc: '已綁定',
  codeTip1: '邀請碼不存在，請重新輸入',
  codeTip2: '已綁定邀請碼',
  copySucc: '複製成功',
  awardName: '獎勵名稱',
  getTime: '獲得時間',
  getCondition: '獲得條件',
  couponText1: '6%off 優惠劵',
  couponText2: '8%off 優惠劵',
  couponText3: '10%off 優惠劵',
  couponText4: '12%off 優惠劵',
  couponText5: '15%off 優惠劵',
  ruleText1: '1.活動時間:2022年11月25日00:00起（UTC)',
  ruleText2: '2.參與遊戲︰Puzzles & Survival',
  ruleText3:
    '3.“官方儲值分享”活動︰分享並邀請好友使用官方儲值頁面，儲值達指定金額即可領取獎勵',
  ruleText4:
    '4.“協力廠商分享月度獎勵”活動︰達成每月分享目標，即可獲得對應獎勵，獎勵每月刷新',
  ruleText5: '5.月度獎勵新玩家需邀請後於協力廠商有進行儲值',
  ruleText6: '6.月度獎勵每月1日進行更新，前一個月進度也將清空',
  ruleText7: '7.獎勵的優惠券需登錄協力廠商支付頁面領取，過期不領將不進行補發',
  ruleText8:
    '8.優惠券幣種以您最後儲值成功的訂單幣種為准，如需更換幣種請聯繫客服',
  ruleText9: '9.雙方玩家無法相互綁定對方邀請碼',
  ruleTableTitle1: '分享獎勵規則如下：',
  ruleTableTitle2: 'VIP檔位元及贈送抵扣券規則如下圖∶',
  ruleTableHead1: '儲值標準',
  ruleTableHead2: '獎勵標準',
  ruleTableHead3: '獎勵',
  ruleTableContent1: '邀請新玩家5人',
  ruleTableContent2: '綁定玩家儲值金額達1000USD',
  errorTip: '操作失敗',
  eventShareText1: '末日喧囂：末日商城限時優惠活動正在開啟中',
  eventShareText2: '海量福利等你來拿',
  cartDoubleTip: '購物車暫不支援使用翻倍券',
  codeTip3: '未登錄',
  codeTip4: '缺少參數',
  codeTip5: '不能綁定自己的邀請碼',
  codeTip6: '已經生成邀請碼',
  payWelfare: '儲值福利',
  wallet: '錢包',
  myDiscount: '我的優惠券',
  knowMore: '瞭解更多',
  backPay: '返回儲值',
  curBalance: '當前餘額',
  pay: '儲值',
  changeCoin: '切換幣種',
  watchDesc: '查看詳細',
  getMore: '獲得更多',
  getDiscount: '領取優惠券',
  notOpenDiscountQuan: '當前未開啟優惠券活動，敬請期待',
  abountZbit: '關於${Z-BIT}',
  remain: '剩餘：',
  payRemain: '支付後預計剩餘',
  payRemainExpiry: '支付後預計剩餘${money} （2026年1月1日失效，請盡快使用）',
  balanceNotEnoughExpiry: '餘額不足（2026年1月1日失效，不支援儲值）',
  balanceNotEnoggh: '餘額不足，請先儲值',
  goToPay: '前往儲值',
  chooseOtherPay: '選擇其他支付方式',
  payIntro: '儲值說明',
  logRole: '登入角色',
  chooseProduct: '選擇商品',
  meAgree: '我已閱讀並同意',
  coinAgreeText: '',
  aboutCoin: '',
  coinsPayTokenLogin: '使用${Z-BIT}前需要進行動態驗證碼驗證',
  dl3dvnVipRule1: '1.參與遊戲︰ ${gameName}',
  dl3dvnVipRule2: '每種活動獎勵僅可領取一次,請及時領取。',
  dl3dvnVipRule3: '2.“登錄送券”活動︰首次登錄儲值頁面，領取15%OFF優惠券',
  dl3dvnVipRule4:
    '3.“VIP積分”活動︰官方支付頁面購買商品積分達到對應等級，即可獲得等級到達優惠券與每週專屬優惠券',
  dl3dvnVipRule5: '4.各幣種積分比例請見附表1，不足1積分則不計入',
  dl3dvnVipRule6: '5.如訂單使用優惠券，積分將以實際支付金額計算',
  dl3dvnVipRule7: '6.積分有效期為365天，VIP等級根據當前有效積分進行變動',
  dl3dvnVipRule8:
    '7.到達VIP等級即可立刻領取首次到達送券&新等級每週送券，後續每週送券於每週六0點（UTC+0）刷新',
  dl3dvnVipRule9:
    '8.每週優惠券需登錄領取，如錯過不進行補發，優惠券獎勵將不定期更新',
  dl3dvnVipRule10:
    '9.優惠券幣種以您最後儲值成功的訂單幣種為准，如需更換幣種請聯繫客服',
  dl3dvnVipRule11: '10.VIP檔位及贈送抵扣券規則如下圖∶',
  dl3dvnVipRule12: '',
  dl3dvnVipRule13: '12.本活動最終解釋權歸 ${gameName} 運營團隊所有。',
  codeTip7: '該玩家已經綁定了您的邀請碼，您無法再使用他的邀請碼進行綁定',
  ruleText10: '10.本活動最終解釋權歸Puzzles & Survival所有。',
  payCoins: '儲值VIP積分',
  shareGift: '分享有禮',
  attentionCoinUse: '注意:不同幣種的餘額不通用',
  noPayWay: '非常抱歉，您所選的地區暫無可用管道，請嘗試其他地區',
  dl3dtwVipRule1: '1.參與遊戲︰ ${gameName}',
  dl3dtwVipRule2: '每種活動獎勵僅可領取一次,請及時領取。',
  dl3dtwVipRule3:
    '2.“VIP積分”活動︰官方支付頁面購買商品積分達到對應等級，即可獲得等級到達優惠券與每週專屬優惠券',
  dl3dtwVipRule4: '3.各幣種積分比例請見附表1，不足1積分則不計入',
  dl3dtwVipRule5: '4.如訂單使用優惠券，積分將以實際支付金額計算',
  dl3dtwVipRule6: '5.積分有效期為365天，VIP等級根據當前有效積分進行變動',
  dl3dtwVipRule7:
    '6.到達VIP等級即可立刻領取首次到達送券&新等級每週送券，後續每週送券於每週六0點（UTC+0）刷新',
  dl3dtwVipRule8:
    '7.每週優惠券需登錄領取，如錯過不進行補發，優惠券獎勵將不定期更新',
  dl3dtwVipRule9:
    '8.優惠券幣種以您最後儲值成功的訂單幣種為准，如需更換幣種請聯繫客服',
  dl3dtwVipRule10: '9.VIP檔位及贈送抵扣券規則如下圖∶',
  dl3dtwVipRule11: '10.本活動最終解釋權歸 ${gameName} 運營團隊所有。',
  eventInviteSucc: '邀請成功',
  eventGainCondition: '獲得條件',
  eventSuccInvite: '成功邀請到好友',
  eventInviteGainOne: '受邀人累儲達49.99USD',
  eventInviteGainTwo: '受邀人累儲達99.99USD',
  eventFriendCode: '您當前擁有的好友邀請碼：',
  eventCheckBind: '是否進行綁定？',
  eventConfirm: '確定',
  eventCancel: '取消',
  eventBindSucc: '成功綁定！',
  eventGainCoupon: '恭喜你，獲得一張優惠劵！',
  eventLookCoupon: '查看優惠劵',
  eventSuccBind: '成功綁定',
  recaptchaTip: '請先進行驗證',
  inputAccountName: '請輸入要找回的帳號',
  pwaPayTip: '更快的支付，更好的體驗',
  pwsInstall: '添加至桌面',
  ztmslgType999: '代金券',
  coinUseTips:
    '代金券將在遊戲內以郵件形式發放，可在遊戲內的代金券商城購買任意商品，消耗代金券時可獲得累計儲值獎勵',
  notice: '公告',
  popupConfirm: '確認',
  hideWithinWeek: '7天內不再顯示',
  ztmslgProductOffTips:
    '近期我們收到了很多熱心玩家對即將到來的支付頁更新的回饋，我們非常重視玩家的聲音。現決定：取消原定於3月13日上線的改動。我們將會繼續不斷優化您的購物體驗，感謝您的理解與支持！如有問題，歡迎諮詢客服。',
  couponTopLimit: '各幣種優惠金額上限',
  swsjpVipRule1: '1．活動時間:2023年3月24日00:00起（UTC)',
  swsjpVipRule2: '2．參與遊戲︰${gameName}',
  swsjpVipRule3: '每種活動獎勵僅可領取一次,請及時領取。',
  swsjpVipRule4: '3.“登錄送券”活動︰首次登錄儲值頁面，領取15%OFF優惠券',
  swsjpVipRule5:
    '4.“VIP積分”活動︰官方支付頁面購買商品積分達到對應等級，即可獲得等級到達優惠券與每週專屬優惠券',
  swsjpVipRule6: '5.各幣種積分比例請見附表1，不足1積分則不計入',
  swsjpVipRule7: '6.如訂單使用優惠券，積分將以實際支付金額計算',
  swsjpVipRule8: '7.玩家歷史儲值已按照一定比例轉換為初始積分',
  swsjpVipRule9: '8.積分有效期為365天，VIP等級根據當前有效積分進行變動',
  swsjpVipRule10:
    '9.到達VIP等級即可立刻領取首次到達送券&新等級每週送券，後續每週送券於每週六0點（UTC+0）刷新',
  swsjpVipRule11:
    '10.每週優惠券需登錄領取，如錯過不進行補發，優惠券獎勵將不定期更新',
  swsjpVipRule12:
    '11.優惠券幣種以您最後儲值成功的訂單幣種為准，如需更換幣種請聯繫客服',
  swsjpVipRule13: '12.本活動最終解釋權歸${gameName}運營團隊所有。',
  beautyVipRule1: '',
  beautyVipRule2: '',
  beautyVipRule3: '',
  beautyVipRule4: '',
  beautyVipRule5: '',
  beautyVipRule6: '',
  beautyVipRule7: '',
  beautyVipRule8: '',
  beautyVipRule9: '',
  beautyVipRule10: '',
  beautyVipRule11: '',
  antslgType999: '代金券',
  passAskMods: '向mod提問',
  passAskModsTip: '關於遊戲的疑問，都可以向mod提問',
  passService: '客服諮詢',
  passServiceTip: '有關帳號、儲值等問題，請聯繫客服',
  passIKonw: '我知道了',
  passGoOn: '繼續諮詢',
  voucherTitle: '官方儲值中心',
  voucherAddHome: '添加至桌面',
  voucherAddHomeTipOne: '更快的支付，更好的體驗',
  voucherAddHomeTipTwo: '點擊工具列的【分享】',
  voucherAddHomeTipThree: '並選擇【添加至桌面】',
  voucherLoginLook: '登錄以查看優惠',
  voucherSwitchRole: '切換角色',
  voucherCoupon: '優惠券',
  voucherVip: 'VIP積分',
  voucherMoreCoupon: '更多優惠',
  voucherAccountId: '帳號ID',
  voucherOtp: '動態驗證',
  voucherOtherWayPay: '使用其他支付方式',
  voucherOtherLoginWay: '使用其他登錄方式',
  voucherCouponActivity: '優惠活動',
  voucherActivityNotBegin: '活動未開始，敬請期待',
  voucherGoCommunity: '前往社群瞭解更多儲值福利',
  voucherValidTime: '有效期',
  voucherLimitRegion: '限${currency}使用',
  voucherLiuyi: '無可用優惠券，請留意官方活動資訊',
  voucherPay: '購買代金券',
  voucherAbout: '關於代金券',
  voucherChooseWay: '選擇支付方式',
  voucherMoreWay: '更多支付方式',
  voucherChooseCoupon: '選擇優惠券',
  voucherHasChoose: '已選擇',
  voucherMoneyInsufficient: '餘額不足',
  voucherContact: '餘額不足，請聯繫客服',
  voucherCouponTotal: '當前可用優惠券數量',
  voucherCouponTipGuide: '選擇支付管道後，在結算時選擇優惠券使用',
  voucherPaytypeNotSupport: '當前支付管道不支援使用優惠券',
  voucherTipSideOne:
    '代金券可用於兌換本遊戲中除了代金券以外的所有禮包及增值服務',
  voucherTipSideTwo: '最高享15%優惠',
  voucherYue: '餘額',
  jpUidLoginName: '',
  jpUidToken: '',
  jpUidInputToken: '',
  pnsBook: '末世生存手冊',
  vipHeadText: '恭喜您已解鎖VIP專屬頭像框',
  vipHeadGetText: '立即領取',
  vipHeadGotText: '已領取',
  vipHeadGetTitle: '確認領取',
  vipHeadGetTip: '每個帳號僅能領取一次，是否領取到當前角色',
  vipHeadAwardText: '金牌指揮官（永久）',
  vipHeadGetErrTip1: '領取失敗，請稍後再試或聯繫客服',
  cartGuideTipNew: '多件支付，優惠同享',
  newVipTitle: '官網儲值中心專屬VIP',
  newVipLogin: '登錄',
  newVipNowPoint: '當前積分：',
  newVipNextLevel: '距離下一級還差 ${point} 積分',
  newVipUpgrade: '立即升級',
  newVipLevel: 'VIP等級福利',
  newVipTip: '優惠券獎勵將於每週六UTC 0點刷新，登錄官網儲值頁面時自動發放。',
  newVipWeekly: '每週贈送',
  newVipReachPoint: '達成要求：',
  newVipRuleInfo: '規則說明：',
  pleaseLang: '選擇一種語言',
  reference: '訂單號',
  saveToNext: '保存以便下次支付使用',
  cardNum: '卡號',
  expireTime: '有效期',
  CVV: '安全碼',
  pleaseCard: '選擇信用卡卡種',
  howToPay: '您打算如何付款？',
  checkCard: '請檢查卡號',
  checkExpiryDate: '請檢查有效期',
  checkCVV: '請檢查安全碼',
  addCard: '新增',
  delete: '刪除',
  deleteCardTips: '刪除存儲的信用卡資料',
  confirmDelete: '是，刪除',
  cancelDelete: '取消',
  checkAllCardMsg: '請檢查卡號、有效期、安全碼是否正確',
  leaveCreditPageTips: '離開頁面會導致訂單支付失敗，是否確認離開',
  sureToLeave: '確認離開',
  continueToPay: '繼續支付',
  pushTest: '推送測試',
  getNoticication: '設備收不到遊戲推送通知？',
  waitCheckResult: '請耐心等待檢測結果，以定位原因~',
  hadAbnormal: '存在檢測項異常，導致可能收不到推送。',
  clickIntro: '請點擊異常項查看解決指引',
  networkCheck: '網路環境檢測',
  noticeAuthorityCheck: '通知許可權檢測',
  noticeBtnCheck: '通知欄開關檢測',
  gmsCheck: 'GMS服務檢測',
  batteryCheck: '電池優化列表檢測',
  pushServiceCheck: '推送服務檢測',
  reCheck: '重新檢測',
  noNoticeAuthorityTip:
    '設備未授予遊戲通知許可權，請前往系統設置-通知，選擇遊戲並打開通知許可權。',
  noNoticeBtnTip:
    '遊戲的通知欄開關未打開，請前往系統設置打開遊戲的通知欄開關。',
  noBatteryTip:
    '遊戲在設備的電池優化清單，可能收不到推送。請前往系統設置-電池-電池優化，將遊戲加入白名單。',
  noPushServiceTip: '推送服務連接失敗，請點擊【連接】按鈕進行伺服器連接',
  noNetworkTip: '當前網路環境異常，請連接穩定的網路後再重試',
  noGmsTip:
    '該設備不支援GMS穀歌移動服務，請更換支援GMS服務的設備登錄以接收通知',
  pushConnectFail: '推送服務連接失敗',
  pushConnectSucc: '推送服務連接成功',
  noGetPushTitle: '如果仍收不到遊戲推送，請按以下步驟檢查：',
  noGetPushContOne: '1、在當前設備退出遊戲後重新登錄遊戲帳號；',
  noGetPushContTwo:
    '2、點擊【推送測試】，將自動下發測試，請留意當前設備是否能接收到；',
  noGetPushContThree:
    '3、若設備能接收到測試推送，但收不到遊戲內推送，請前往遊戲-設置-通知，檢查遊戲內相關通知項是否已打開；',
  noGetPushContFour: '4、若按以上操作仍收不到推送，請聯繫客服協助處理。',
  getPushSucc: '設備已成功接收上一條測試推送，推送功能正常！',
  allCheckSucc: '所有檢測項正常！',
  pushCheck: '推送檢測',
  useDirectPay: '使用快捷支付',
  paypalFraudnetInfo: '支付資訊受Paypal風控引擎保護',
  goToSetting: '前往設置',
  retry: '重試',
  connect: '連接',
  canRebind: '解綁後，您可以重新進行綁定',
  agreePlatform: '我已同意${service}和${privite}',
  sendGameNews: '訂閱遊戲最新資訊',
  canNotBindEmail: '解綁後，將無法使用該郵箱進行登錄',
  canNotBindPhone: '解綁後，將無法使用該手機號碼進行登錄',
  canChangeByEmail: '通過郵箱可以在不同設備切換登錄',
  canChangeByPhone: '通過電話號碼可以在不同設備切換登錄',
  loginSucc: '登錄成功',
  phoneHadBind: '該手機號帳號已被綁定，是否直接登錄',
  emailHadBind: '該郵箱帳號已被綁定，是否直接登錄',
  phoneNotBind: '該手機號帳號未綁定，是否創建新帳號',
  emailNotBind: '該郵箱帳號未綁定，是否創建新帳號',
  emailAccount: '郵箱帳號',
  phoneAccount: '手機號碼帳號',
  phoneInputError: '手機號碼格式錯誤',
  registerNewAccount: '註冊新帳號',
  secureTip: '關於代儲及帳號安全提示',
  toTop: '置頂',
  createNewWork: '創建新的工單',
  serviceEvaluate: '客服評價',
  emailRemind: '郵箱提醒',
  isAgreeService: '您對我們的服務滿意嗎？',
  thankEvaluateTop: '感謝您寶貴的評價！',
  inputValidEmail: '請輸入有效郵箱',
  replyWillRemind:
    '客服回覆後，您的郵箱會收到提醒郵件。若要取消此功能請再次點擊郵箱提醒功能即可。',
  isCancelEmailRemind: '是否取消郵箱提醒？取消後將無法接收提醒郵件哦～',
  reconfirmEmail: '請您確認郵箱是否正確',
  confirmCanSubmit: '確認後可提交工單',
  serviceWillReply: '客服回復後會通過郵箱提醒',
  cancelEmailRemind: '您是否要取消【郵箱提醒】？',
  yes: '是',
  no: '否',
  inputWorkSearch: '請輸入搜尋關鍵字',
  loading: '加載中',
  loadingError: '載入失敗，請點選重新載入...',
  noMore: '沒有更多了',
  cancelToTop: '取消置頂',
  evaluateOne: '很不滿意',
  evaluateTwo: '不滿意',
  evaluateThree: '一般',
  evaluateFour: '滿意',
  evaluateFive: '很滿意',
  confirmDelWorkTop: '確認刪除此工單？',
  reRemindEmail: '想再次透過電子郵件提醒您？ 您可重新點選【信箱提醒】。',
  confirmWillReply: '確認後，客服回復後會通過郵箱提醒',
  thankEvaluateBottom: '您的評價是提升我們服務品質的動力！',
  confirmDelWorkBottom: '刪除後不可回覆哦～',
  morePurchaseWay: '更多儲值方式',
  purchaseNeed: '購買商品需要：',
  videoUploadSucc: '影片上傳成功',
  videoUploadFail: '影片上傳失敗',
  videoUploadLimit:
    '只能上傳mp4格式的影片，影片大小不能超過400Mb，影片時長不能超過2分鐘。',
  imageUploadSucc: '圖片上傳成功',
  imageUploadFail: '圖片上傳失敗',
  uploading: '上傳中',
  smartOrderCreate: '快速創建工單',
  smartOrderSearch: '搜索',
  smartOrderComing: '敬請期待',
  smartOrderContactService: '聯繫客服',
  smartOrderDetector: '診斷助手',
  smartOrderDetect: '診斷',
  smartOrderDetecting: '診斷中',
  smartOrderDetectTip:
    '檢測到您遊玩過程中遊戲遇到問題，請您點擊診斷，我們將幫您定位問題。',
  smartOrderDetectTip2: '已經幫您定位問題，提交工單後，我們會幫您解決問題!',
  smartOrderSubmit: '提交',
  smartOrderIKnow: '我知道了',
  smartOrderConfirm: '確定',
  smartOrderLook: '查看',
  smartOrderIsHelp: '這篇文章對您是否有幫助？',
  smartOrderInputQuestion: '請輸入您的問題',
  smartOrderPleaseInpt: '請輸入',
  smartOrderPleaseChoose: '請選擇',
  smartOrderStoreTime: '儲值時間',
  smartOrderInputOrder: '請輸入訂單號',
  smartOrderInputPrice: '請輸入訂單金額',
  smartOrderNeedHelp: '您好，請問需要什麼幫助？',
  smartOrderLookHelpTip: '您可以查看常見問題的解決方法',
  smartOrderNoResult: '暫無搜索結果，請嘗試搜索其他內容',
  smartOrderUpdateTime: '最新修改時間',
  smartOrderSelectStoreTime: '請選擇儲值時間',
  smartOrderAtlestChoose: '請至少填寫一項',
  pwaInstallAward: '添加至桌面',
  getMasonry: '領獎鑽石',
  addToDrawerVisit: '添加至桌面方便下次訪問',
  immeAddToGet: '馬上添加，即可領取限時獎勵',
  add: '添加',
  talkNextTime: '下次再說',
  chooseRoleGetGift: '選擇角色以領取獎勵',
  getGiftSuccess: '領取成功，請在遊戲內查看獎勵',
  dmaTitle: '個性化廣告',
  newAdd: '新增',
  smartDelete: '刪除',
  wordLengthTip: '(0-600字)',
  areaLimitSwitchRegion: '更換地區',
  areaLimitCurrentRegionCurrency: '當前地區和支付幣種',
  areaLimitRegion: '地區：',
  areaLimitCurrency: '支付幣種：',
  areaLimitNote: '注意：',
  areaLimitSwitchLimitation: '單個帳號在每個自然年內僅可切換1次地區',
  areaLimitPostSwitchCoupon:
    '完成切換後，新獲得的優惠券將根據新的地區對應幣種進行發放。',
  areaLimitRemainingSwitches: '當前剩餘次數：${times}',
  areaLimitNoRemainingSwitches: '無剩餘次數',
  areaLimitUnableToSwitchThisYear: '今年內無法再次修改',
  areaLimitCannotSwitch: '無法修改',
  areaLimitNavigateToSwitch: '前往修改',
  areaLimitConfirmSwitch: '確認修改',
  areaLimitPreSwitchRegionCurrency: '切換前地區和支付幣種',
  areaLimitPostSwitchRegionCurrency: '切換後地區和支付幣種',
  areaLimitPostSwitchRestriction: '成功切換後，今年內不可再次切換支付地區。',
  areaLimitUnusedZBitWarning:
    '您還有未使用的Z-Bit，切換地區後可能無法使用Z-Bit，是否繼續？',
  areaLimitConfirm: '確認',
  areaLimitCancel: '取消',
  areaLimitInconsistencyWarning: '您的訪問地區跟支付地區不一致',
  areaLimitPromptToSwitch: '是否需要更換地區？',
  areaLimitEnterZipCode: '*Please enter your zipcode',
  areaLimitEnterInvalid: 'Zipcode is invalid, please re-enter',
  areaLimitTaxRateTips:
    'Depending on your location, the tax rate may vary, the payment amount shall prevail',
  areaLimitInfoCollect:
    'For information collection protection, please refer to the Privacy Policy',
  getAward: '領取獎勵',
  selectProductTitle: '選擇商品',
  hotSuggest: '熱門推薦',
  inputKeywordSearch: '輸入關鍵字搜索',
  lookProductContent: '查看商品內容',
  popupClose: '關閉',
  productSwitch: '更換商品',
  confirmBuy: '確認購買',
  thinkLater: '再想想',
  areaLimitConfirmRegion: '確認地區',
  areaLimitContinuePay: '繼續支付',
  areaLimitSwitchLimitationTwice: '單個帳號在每個自然年內僅可切換2次地區',
  dtmslgVipRule1: '1.參與遊戲︰ ${gameName}',
  dtmslgVipRule2: '每種活動獎勵僅可領取一次,請及時領取。',
  dtmslgVipRule3:
    '2.“VIP積分”活動︰官方支付頁面購買商品積分達到對應等級，即可獲得等級到達優惠券與每週專屬優惠券',
  dtmslgVipRule4: '3.各幣種積分比例請見附表1，不足1積分則不計入',
  dtmslgVipRule5: '4.如訂單使用優惠券，積分將以實際支付金額計算',
  dtmslgVipRule6: '5.積分有效期為365天，VIP等級根據當前有效積分進行變動',
  dtmslgVipRule7:
    '6.到達VIP等級即可立刻領取首次到達送券&新等級每週送券，後續每週送券於每週六0點（UTC+0）刷新',
  dtmslgVipRule8:
    '7.每週優惠券需登錄領取，如錯過不進行補發，優惠券獎勵將不定期更新',
  dtmslgVipRule9:
    '8.優惠券幣種以您最後儲值成功的訂單幣種為准，如需更換幣種請聯繫客服',
  dtmslgVipRule10: '9.VIP檔位及贈送抵扣券規則如下圖∶',
  dtmslgVipRule11: '10.本活動最終解釋權歸 ${gameName} 運營團隊所有。',
  dtmslgType10010: '每日特惠',
  dtmslgType10020: '限量供應',
  dtmslgType10030: '英雄',
  dtmslgType10040: '戰鬥裝備',
  dtmslgType10050: '符文',
  dtmslgType10060: '圖騰',
  dtmslgType10070: '聖石',
  dtmslgType10080: '巨龍',
  dtmslgType10090: '資源',
  dtmslgType10100: '建造研發',
  dtmslgType10110: '稀缺商品',
  dtmslgType10120: '命運武裝',
  dtmslgType10130: '鑽石',
  dtmslgType10140: '代金劵',
  dtmslgType2: '活動禮包',
  dtmslgType3: '福利中心',
  dtmslgType4: '觸發禮包',
  dtmslgType5: '主介面禮包',
  dtmslgType20010: '黑色星期五',
  dtmslgType20021: '五日大禮',
  dtmslgTypeother: '其他',
  rightsIntro: '',
  '213RightsIntro':
    '因功能煥新，原「VIP 積分」活動即將下線。<br />\n 原「VIP 積分」活動所得優惠券請您及時使用，避免超出優惠券有效期限。<br />\n 下線時間：2024-08-19 08:00:00 (utc)<br />\n 活動下線後，您可前往大會員中心體驗更多權益：<br />\n 完成任務獲取積分，使用積分即可兌換優惠券、遊戲道具等獎勵！還有專屬會員權益、積分抽獎等福利活動。<br />\n 敬請期待。',
  '263RightsIntro':
    '因功能煥新，原「VIP 積分」活動即將下線。<br />\n 原「VIP 積分」活動所得優惠券請您及時使用，避免超出優惠券有效期限。<br />\n 下線時間：2024-09-28 00:00:00(UTC)<br />\n 活動下線後，您可前往大會員中心體驗更多權益：<br />\n 完成任務獲取積分，使用積分即可兌換優惠券、遊戲道具等獎勵！還有專屬會員權益、積分抽獎等福利活動。<br />\n 敬請期待。',
  goToRights: '前往大會員中心',
  oldVipIntro: '原「VIP積分」活動所得優惠券請您及時使用，避免超出優惠券有效期限。',
  'pwa-20001': '請先登錄',
  'pwa-20002': '參數錯誤',
  'pwa-20003': '未綁定角色',
  'pwa-20004': '獎勵發放失敗，請重試或聯繫客服',
  'pwa-20005': '已經領取該獎勵',
  'pwa-20100': '活動還沒開始，請耐心等待',
  'pwa-20101': '活動已結束，謝謝參與',
  'pwa-20102': '未到領獎時間',
  'pwa-20103': '領獎時間已結束',
  'pwa-1001': '系統繁忙，請稍後再試',
  pwaCommon: '系統繁忙，請稍後再試',
  zipCodeSwitchZipCode: 'Switch zipcode',
  zipCodeState: 'state',
  zipCodeRate: 'rate',
  '-': '-',
  officialStore: '官方儲值中心',
  headerSafeTip: '安全無風險 極速到賬',
  safeChecking: '...正在檢測當前支付環境',
  safeChecked: '安全,可放心使用',
  riskChecked: '存在風險,請謹慎操作',
  footerSafeTitle1: '安全',
  footerSafeTitle2: '便捷',
  footerSafeTitle3: '實惠',
  footerSafeTitle4: '高效',
  footerSafeContent1: '官方儲值中心',
  footerSafeContent2: '支持超多支付方式',
  footerSafeContent3: '優惠折扣,更多限時福利',
  footerSafeContent4: '極速到賬,無延遲',
  limitedTimeActivityTitle: '限時福利',
  limitedTimeActivityTime: '活動時間： ${startDate} - ${endDate}（UTC）',
  limitedTimeActivityTaskProcess: '(當前 ${curPay}/${targetPay})',
  limitedTimeActivityRateTips: '（匯率有一定變動，請以此頁面展示為准）',
  limitedTimeActivityNotAchieve: '未完成',
  limitedTimeActivityClaim: '領取',
  limitedTimeActivityClaimed: '已領取',
  limitedTimeActivityTimeLeft: '限時： ${days}d ${hours}:${minutes}:${seconds}',
  limitedTimeActivityRecord: '領取記錄',
  limitedTimeActivityAward: '獎勵',
  limitedTimeActivityGotTime: '領取時間',
  limitedTimeActivityGotRole: '領取角色',
  limitedTimeActivityRule: '活動規則',
  limitedTimeActivity285Rule1: '1.活動時間：  ${startDate} - ${endDate}（UTC）',
  limitedTimeActivity285Rule2:
    '2.活動時間內，完成限時任務即可領取獎勵，任務分類每週任務以及每月任務：',
  limitedTimeActivity285Rule3:
    '（1）每週任務：每個帳號限定完成一次，每週一0點重置',
  limitedTimeActivity285Rule4:
    '每週登錄任務：限定時間內，完成一次登錄官網儲值頁面；',
  limitedTimeActivity285Rule5:
    '完成一次任意金額儲值：限定時間內，在官網儲值頁面上，完成一筆儲值，任意金額均可完成任務。',
  limitedTimeActivity285Rule6:
    '（2）每月任務：每個帳號限定完成一次，每月1號0點',
  limitedTimeActivity285Rule7:
    '登錄任務：限定時間內，完成一次登錄官網儲值頁面；',
  limitedTimeActivity285Rule8:
    '累計儲值任務：限定時間內，在官網儲值頁面上，累計儲值達到任務檔位，即可領取一次獎勵',
  limitedTimeActivity285Rule9:
    '注意：由於活動時間持續較長，匯率可能會有變動，儲值金額請以頁面展示為准',
  limitedTimeActivity285Rule10:
    '3.領取獎勵前，需要先選擇一個角色進行領取，領取後請在遊戲內查看獎勵',
  limitedTimeActivityClaimAward: '領取獎勵',
  limitedTimeActivityConfirmGot: '確認領取',
  limitedTimeActivityGetSucc: '領取成功',
  limitedTimeActivityGetFail: '領取失敗，請稍後再試或聯繫客服',
  limitedTimeActivityFrequent: '請勿頻繁操作',
  limitedTimeActivityLoginFirst: '請先登錄',
  limitedTimeActivityWrongParam: '參數錯誤',
  limitedTimeActivityOverTips: '活動已過期，請刷新頁面',
  preRightsIntro:
    '因功能煥新，原「VIP 積分」活動即將下線。<br />下線時間：${offLineDate}<br />原「VIP 積分」活動所得優惠券請您及時使用，避免超出優惠券有效期限。<br />活動下線後，您可前往大會員中心體驗更多權益：<br />完成任務獲取積分，使用積分即可兌換優惠券、遊戲道具等獎勵！還有專屬會員權益、積分抽獎等福利活動。<br />敬請期待。',
  riskTipTitle: '警惕違規不良行為及詐騙風險',
  riskTipContent:
    '親愛的玩家，\n\n爲營造公平有序，健康多元的遊戲環境，我們建議諸位玩家警惕以下破壞遊戲秩序及公平性的違規不良行爲，常見的有：\n\n1. 發布違規廣告：透過聊天等管道發布違規廣告，如非法資源交易、非法代充等；\n2. 使用外掛或腳本：在遊戲內使用外掛或腳本等技術手段進行違規批量獲得資源；\n3. 違規邀請：聊天時發送與遊戲內容無關的違規邀請，誘導透過遊戲外管道(如Line、Discord)進行聯繫；\n4. 非法代充：以低價儲值折扣為誘餌，引導玩家進行非官方儲值；\n5. 其他形式詐騙，如冒充官方人員等。\n\n我們希望提醒各位玩家，請各位保護好財產和個人資訊，切勿相信任何違規及詐騙資訊。以上違規行為有許多風險，不僅可能會使您面臨帳號被盜用的風險，且可能涉及詐欺行為，對於涉及違規行為所導致的損失，我們不支持給予任何的補償。\n\n對於違規的帳號，我們會視違規情況嚴重程度及影響範圍採取行動，包括但不限於警告、扣除非法收益、暫時或永久封禁遊戲帳號等措施。如果您在遊戲中遇到任何可疑行為，可以透過聯絡客服向我們舉報。我們將盡快確認並及時採取措施，感謝您的理解與支持。',
  linkValid: '該鏈接已失效',
  accountLabel: '帳號',
  passwordLabel: '密碼',
  confirmPasswordLabel: '確認密碼',
  confirmDeleteTitle: '請確認是否刪除遊戲帳號及帳號下所有角色',
  confirmDeleteYes: '是，我確認刪除遊戲帳號及帳號下所有角色',
  selectGame: '請選擇遊戲',
  confirmDeleteNo: '否，我只需要刪除某個角色，遊戲帳號保留',
  delTermsTitle: '請您細讀賬號刪除的條件和須知',
  delCondTitle: '1. 賬號刪除條件',
  delCond1:
    '(1) 該遊戲賬號及所屬遊戲角色是您本人註冊及使用，<span>請登入賬號後再進行申請</span>，如果賬號無法登入，請先進行[賬號找回]。',
  delCond2:
    '(2) 該遊戲賬號及所屬遊戲角色<span>沒有任何安全風險</span>，包括但不限於：沒有未處理完畢的投訴、舉報、調查、仲裁、訴訟等，及未處理完畢的被投訴、被舉報、被調查、被仲裁、被投訴、被訴訟等。',
  delCond3:
    '(3) 該遊戲賬號及所屬遊戲角色下<span>沒有任何待結清的應付未付款項</span>，包括但不限於退款未結清，訂閱未取消等。',
  delNoticeTitle: '2. 帳號刪除須知',
  delNotice1:
    '(1) 您申請刪除的是該遊戲帳號及所屬遊戲角色，一旦<span>刪除完成，將無法登入、無法恢復</span>。',
  delNotice2:
    '(2) 請您<span>優先結清您帳號及所屬角色下的遊戲內資產</span>，包含但不限於遊戲道具，遊戲代金幣，遊戲內訂閱等，一旦刪除完成，遊戲內資產將會全部刪除，遊戲停服後，已刪除帳號及所屬角色不安排退款。 \n',
  delNotice3:
    '(3) 遊戲帳號及所屬角色資料一旦刪除，該帳號下相關信息也會被刪除或匿名化處理，但第三方社交媒體的登入信息（如Facebook關聯登入等），請玩家自行解除綁定並在對應社交平台進行信息清理。 \n',
  delNotice4:
    '(4) 為了保障您的權益，我們會為您提供14天的保留期限（部分地區基於地方法規要求除外），即冷靜期，在冷靜期內您可聯繫客服提單申請取消刪除。 \n',
  delNotice5:
    '(5) 您的帳號刪除一旦申請成功提交，我們會立即凍結，但刪除數據需要大約一周時間才能處理完畢，因此我們會在徹底刪除後第一時間對您進行郵件通知。',
  delFormConfirm1: '我已細讀並了解，刪除帳號的條件及後果',
  delFormConfirm2: '我申請刪除的帳號無相關未完結舉報及訴訟',
  delForm:
    '我已閱讀並同意<a class="account-delete-link" href="javascript:;">《帳號註銷協議》</a>',
  cannotDeleteMsgTitle: '無法進行帳號刪除',
  cannotDeleteMsg1: '由於您的帳號未滿足以下條件，因此無法進行帳號刪除：',
  cannotDeleteMsg2:
    '系統檢查到您有客訴單未處理完成，請在客訴單完結後再次提交申請。',
  cannotDeleteMsg3:
    '系統檢查到您有退款未補齊結清，請補齊退款後再提交帳號刪除申請。',
  cannotDeleteMsg4:
    '系統檢查到您正在被其他玩家投訴或舉報中，請等待客訴完結後再次提交申請。',
  formCompleted: '工單填寫已完成',
  formCheckMsg1: '您的工單已經填寫完畢，請耐心等待客服人員進行審核並回覆工單。',
  formCheckMsg2:
    '您可以在<span class="account-delete-link">[我的工單]</span>中查看工單處理的進度。',
  delEmailMsg1: '在完成刪除後，是否需要我們以郵件方式通知您？',
  delEmailMsg2:
    '由於賬號刪除涉及大量的數據處理，通常需要約一周的時間來完成徹底刪除，我們是否需要在刪除完畢後，以郵件的方式通知您？',
  delEmailMsg3: '您所提供的郵件地址僅用於通知，不會用於其他用途。',
  delEmailConfirmYes: '是的，請透過郵件通知我',
  delEmailFill: '請填寫接收通知的郵箱地址',
  delEmailConfirmNo: '不，我不需要郵件通知',
  delCoolMsg1: '是否選擇14天的冷靜期？',
  delCoolMsg2:
    '在這14天的冷靜期內，您的帳號將會被凍結，但您可以隨時提交申請撤銷刪除。如果14天後，您未有撤銷，帳號將會被刪除，並且無法恢復。',
  delCoolMsg3:
    '如果您選擇不需要冷靜期，則在申請完成後將立即進行帳號刪除，並且無法恢復。',
  delCoolConfirmYes: '是的，我希望有14天的冷靜期',
  delCoolConfirmNo: '否，我希望立即刪除',
  delSecondCheckMsg1:
    '您確定已經處理好帳號所有內容，並現在進行帳號冷卻期？一旦執行，您的帳號將無法登入',
  delSecondCheckConfirmYes: '是的，立即開始',
  delResMsg1: '您的帳號刪除申請已經提交，以下帳號已被凍結，無法登入：',
  gameName: '遊戲名稱：',
  gameAccount: '遊戲帳號：',
  delResMsg2:
    '<span>請截圖並複製以上帳號信息，如果您需要在冷卻期內恢復帳號，這是唯一的證明</span>',
  delResMsg3: '冷卻期共14天，倒數計時：',
  delResMsg4:
    '如果您在冷卻期內需要撤銷刪除申請，請在冷卻期內點擊下方[聯絡客服]',
  copyAccountInfo: '複製帳號信息',
  delResMsg5:
    '您已完成帳號刪除申請，目前帳號已在刪除中，因此您的帳號現在開始已無法登入。',
  delResMsg6:
    '由於帳號刪除需要處理的數據較大，處理需要時間，因此帳號痕跡不會馬上全部抹除，我們會在大約一週內完成。',
  delResMsg7: '若您之前已經填寫通知郵箱地址，我們將發送郵件至您的指定郵箱。',
  delResMsg8: '若您需要再次登入遊戲，可重新註冊新帳號登入。',
  appleOption: 'App Store',
  googleOption: 'Google Play',
  otherOption: '其他渠道',
  itemWrong: '此項填寫有誤，請重新輸入',
  delRegisterTime: '註冊時間',
  delDevice: '常用機型',
  delIp: '常用IP',
  delHistoryPayChannel: '歷史儲值渠道',
  delHistoryPayOrder: '歷史儲值訂單編號',
  delDeleteReason: '刪號原因',
  delPrevStep: '上一步',
  delNextStep: '下一步',
  delSecondCheckMsg2:
    '您確定已經處理好帳號所有內容，並現在執行帳號刪除？執行後您的帳號將無法登入',
  pleaseFillIn: '請填寫以下資訊',
  switchNewVersion: '切換至新',
  switchNewVersionPlatform: '支付平台',
  updateVersionPopupContent: '為確保流暢的遊戲性能及後續新功能的支持，我們推薦您將設備系統升級，以便享受更穩定的運行體驗與兼容性優化。',
  selectTopupTips: "90%玩家選擇官方儲值中心",
  chuzhi: "儲值",
  selectMethods: "儲值方式",
  landscapeTip2: "請將手機豎屏使用以獲得更好的體驗",
  v3LaunchFromDesktopAndRewardToMailbox: '請從桌面啟動\n選擇角色後獎勵將發送至信箱',
  '-': '-',
};
